// removed by extract-text-webpack-plugin
module.exports = {"compare-funds":"compare-funds__3I-Ku","search-title":"search-title__19n-j","search-input":"search-input__3sqTz","datapoints":"datapoints__2koKw","title":"title__1tsm_","table":"table__U5siG","fund-header":"fund-header__6xBj2","fund-row":"fund-row__2WFth","empty-row":"empty-row__2UT7h","fund-image":"fund-image__otVJF","delete-fund":"delete-fund__1Lt_n","filter-select":"filter-select__2CT3r","table-container":"table-container__3EF6H","table-controls":"table-controls__25sx2"};


//////////////////
// WEBPACK FOOTER
// ./styles/compareFunds.scss
// module id = 723
// module chunks = 68